import { render } from "./NavigationForm.vue?vue&type=template&id=0c5c84e1&scoped=true"
import script from "./NavigationForm.vue?vue&type=script&lang=js"
export * from "./NavigationForm.vue?vue&type=script&lang=js"

import "./NavigationForm.vue?vue&type=style&index=0&id=0c5c84e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5c84e1"]])

export default __exports__